import { render, staticRenderFns } from "./shopNav.vue?vue&type=template&id=5f3ec08c&scoped=true"
import script from "./shopNav.vue?vue&type=script&lang=js"
export * from "./shopNav.vue?vue&type=script&lang=js"
import style0 from "./shopNav.vue?vue&type=style&index=0&id=5f3ec08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ec08c",
  null
  
)

component.options.__file = "shopNav.vue"
export default component.exports